import Configuration from '@/models/dackpartner/Configuration'
import DiameterConfig from '@/models/dackpartner/DiameterConfig'
import SupplierConfig from '@/models/dackpartner/SupplierConfig'
import AmountConfig from '@/models/dackpartner/AmountConfig'
import PercentageConfig from '@/models/dackpartner/PercentageConfig'

export function createDefaultConfiguration(): Configuration {
  const config = new Configuration()

  // Default winter setting
  config.isWinter = false

  config.suppliersConfig = [
    new SupplierConfig({
      supplierId: null,
      brandId: null,
      discountPercent: 0,
      profitPercent: 0,
      profitAmount: 0,
      amountConfig: new AmountConfig(),
      percentageConfig: new PercentageConfig(),
    }),
  ]

  config.diameterConfig = new DiameterConfig()

  return config
}
